export default __webpack_public_path__ + "static/media/room-2-theme.874fc3c4.jpg";